import React, { useContext } from "react";
import themeContext from "../../../../context/theme/ThemeContext";

const ProgressBar = ({ progressComplete }) => {
  const { themeName, getThemeColor } = useContext(themeContext);
  return (
    <div
      style={{
        height: "15px",
        backgroundColor: themeName !== "light"?"#303030":"rgb(214 210 210)",
        borderRadius: "15px",
      }}
    >
      <div
        style={{
          height: "15px",
          backgroundColor: "#0085FF",
          width: `${progressComplete <= 25 ? "25" : progressComplete}%`,
          borderRadius: "15px",
          fontSize: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
        className="progress-bar-transition"
      >
        <span style={{marginRight: "5px",color: "#FFF", fontWeight:"500"}}>{progressComplete}%</span>
      </div>
    </div>
  );
};

export default ProgressBar;
